export default "__VITE_ASSET__IySvt2Hm__"